<template>
  <div class="row">
  	<div class="card col-12" style="width: 18rem;">
	  	<div class="card-body my-5 ">
	  		<div v-bind:class="loading">
		      <div class="d-flex justify-content-center">
		        <div class="spinner-border m-5" role="status">
		          <span class="sr-only">Loading...</span>
		        </div>
		      </div>
		    </div>
		    <div v-bind:class="result">
		  		<div class="row justify-content-center">
					<form class="col-md-6 text-center" autocomplete="off" v-on:submit.prevent="Registrar">
					    <h5 class="card-title">Registro para Exámen</h5>
					    <h6 class="card-subtitle mb-2 text-muted">Ingresa tus datos</h6>
					    <div class="form-group mt-4">
						    <label for="no_ceneval">Folio Ceneval</label>
						    <input type="text" v-model="no_ceneval" class="form-control w-50 mx-auto text-center" id="no_ceneval">
						</div>
						<div class="form-group">
						    <label for="matricula">Matricula UANL</label>
						    <input type="text" v-model="matricula" class="form-control mx-auto text-center w-50" id="matricula">
						    <small id="emailHelp" class="form-text text-muted">Si no tienes matricula de la UANL no llenes este campo</small>
						</div>
						<div class="form-group">
						    <label for="nombre">Nombre Completo</label>
						    <input type="text" v-model="nombre" class="form-control mx-auto text-center" id="nombre">
						</div>
						<div class="form-group d-none">
							<label for="concepto">Exámen</label>
						    <select class="form-control" id="concepto" v-model="idconcepto">
						      <option v-for="concepto of conceptos" v-bind:value="concepto.idconcepto">{{concepto.concepto}}</option>
						    </select>
						 </div>
					    <button v-if="listo" type="submit" class="btn btn-primary mt-4">Registrar</button>
					    <button v-else type="button" class="btn btn-primary mt-4">Registrar</button>
					</form>
		  		</div>
		  		<div class="row mt-5">
		  			<div class="col-12 text-center">
		  				<small>
							<a href="" v-on:click.prevent="Reimprimir_Registro" class="btn-link">
								Reimprimir Hoja de Registro
							</a>
						</small>
					</div>
		  		</div>
		  	</div>
	  	</div>
	</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      listo:false,
      no_ceneval:'',
      idconcepto:null,
      nombre:'',
      matricula:'',
      conceptos:[]
    }
  },
  methods:{
  	Registrar(){
  		if (!this.Validar()) {return;}
  		if (this.matricula.length==0) {
  			this.idconcepto=this.conceptos[1].idconcepto;
  		}
  		this.Cargando();
		this.$http.post('solicitudes',{
			no_ceneval:this.no_ceneval,
			matricula:this.matricula,
			idconcepto:this.idconcepto,
			nombre:this.nombre
		})
		.then(respuesta=>{return respuesta.json()})
		.then(respuestaJson=>{
			this.Listo();
			if (respuestaJson.resp=='Excelente') {
			  this.$router.push({name:'Imprimir_Registro',params:{
			  	idsolicitud:respuestaJson.idsolicitud
			  }});
			}else{
			  swal("¡Ups!",respuestaJson.resp, "error");
			}
		})
		.catch(error=>{
			this.Listo();
			swal("Favor de Intentar mas tarde", "Problemas para generar inscripción", "error");
		});
  	},
  	Validar(){
  		var pasar = true;
  		if (this.no_ceneval.length==0) {
  			pasar=false;
  			swal("Datos incompletos","El No. de Ceneval es obligatorio", "error");
  		}else if (this.nombre.length==0) {
  			pasar=false;
  			swal("Datos incompletos","El nombre es obligatorio", "error");
  		}
  		return pasar;
  	},
  	Consultar_Conceptos(){
  		this.Cargando();
  		this.$http.get('conceptos')
		.then(respuesta=>{return respuesta.json()})
		.then(respuestaJson=>{
			this.Listo();
			this.conceptos=respuestaJson;
			if (this.conceptos.length>0) {
				this.idconcepto=this.conceptos[0].idconcepto;
			}
			this.listo=true;
		})
		.catch(error=>{
			this.Listo();
			swal("Problemas para abrir el registro","Favor de Intentar mas tarde", "error");
		});
  	},
  	Reimprimir_Registro(){
  		this.$router.push({name:'Reimprimir_Registro'});
  	},
  	Cargando(){
  		this.loading='';
  		this.result='d-none';
  	},
  	Listo(){
  		this.loading='d-none';
  		this.result='';
  	}
  },
  created(){
  	localStorage.apikeySiepsBiologicasUanl=JSON.stringify("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzaWVwc191YW5sX3Bvc2dyYWRvIiwiZGF0YSI6eyJpZHNvbGljaXR1ZCI6IjEiLCJpZGFsdW1ubyI6IjEifSwiaWF0IjoxNzE4ODM2MTM2LCJleHAiOjIwMzQzNjg5MzZ9.duBO5wP9M2_ttUAxXwcAIeIoxw0zom2Nlr0qX4RM7yg");
  },
  mounted(){
  	this.Consultar_Conceptos();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Registro.vue